import { api } from "./configs/axiosConfigs"

export const SoftnetAPI = {
    importWarehouse: async () => {
        const response = await api.post(
            '/softnet/importWarehouse'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importBusinessArea: async () => {
        const response = await api.post(
            '/softnet/importBusinessArea'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importFormaPago: async () => {
        const response = await api.post(
            '/softnet/importFormaPago'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    issueTicket: async (id: number, data: any) => {
        const response = await api.post(
            `/softnet/issueTicket/${id}`, data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importProducts: async () => {
        const response = await api.post(
            '/softnet/importProducts'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importCategories: async () => {
        const response = await api.post(
            '/softnet/importCategory'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importSubcategories: async () => {
        const response = await api.post(
            '/softnet/importSubcategory'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getWarehousesERP: async (data?: any) => {
        const response = await api.get(
            '/softnet/warehouse', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectWarehouse: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectWarehouse', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getBusinessArea: async (data?: any) => {
        const response = await api.get(
            '/softnet/businessArea', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectBusinessArea: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectBusinessArea', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getWayToPaysERP: async (data?: any) => {
        const response = await api.get(
            '/softnet/formaPago', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectWayToPay: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectFormaPago', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getProductsERP: async (data?: any) => {
        const response = await api.get(
            '/softnet/products', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectProducts: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectProducts', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getCategoriesERP: async (data?: any) => {
        const response = await api.get(
            '/softnet/category', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectCategory: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectCategory', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getSubcategoriesERP: async (data?: any) => {
        const response = await api.get(
            '/softnet/subcategory', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectSubcategory: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectSubcategory', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importSpecificsubcategory: async () => {
        const response = await api.post(
            '/softnet/importSpecificsubcategory'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getSpecificsubcategory: async (data?: any) => {
        const response = await api.get(
            '/softnet/specificsubcategory', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectSpecificsubcategory: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectSpecificsubcategory', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importCustomer: async () => {
        const response = await api.post(
            '/softnet/importCustomer'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getCustomers: async (data?: any) => {
        const response = await api.get(
            '/softnet/customer', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectCustomer: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectCustomer', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importSupplier: async () => {
        const response = await api.post(
            '/softnet/importSupplier'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getSuppliers: async (data?: any) => {
        const response = await api.get(
            '/softnet/supplier', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectSupplier: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectSupplier', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    importBranchOffice: async () => {
        const response = await api.post(
            '/softnet/importBranchOffice'
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getBranchOffice: async (data?: any) => {
        const response = await api.get(
            '/softnet/branchOffice', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    importSelectBranchOffice: async (data: any) => {
        const response = await api.post(
            '/softnet/importSelectBranchOffice', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
}